import React from 'react';
import GalleryModal from '@hpstellar/pdp/GalleryModal';

import withPageComponents from '../../../../page/components/with-page-components';
import { PriceContainer } from '../../../../product/components/product-price/with-product-price';
import AddOnPrice from '../../../../product/components/product-configurations/addon-price';
import { withAddToCart } from '../../../../product/components/purchase-button-container';

const EMPTY_OBJECT = {};

const mapImages = (images) => {
    return images.map(i => {
        return {
            url: i.xlarge || i.lrg || i.src,
            type: i.type
        }
    })
}

const getModalData = (product, images, currentPrice) => {
    if (product) {
        const { ctaText, ctoLink, customizeText, isOOS } = currentPrice || {};
        const { name, isComingSoon } = product;
        const price = currentPrice ? {
            currencySymbol: '$',
            regularPrice: currentPrice.regularPrice,
            salePrice: currentPrice.salePrice,
            productType: product.prdClass.toLowerCase()

        } : EMPTY_OBJECT;
        return {
            data: {
                images: mapImages(images),
                ratings: {
                    score: product.rating,
                    reviewsCount: product.numReviews
                },
                title: name,
                price,
                sku: product.sku,
                outOfStock: !isComingSoon ? isOOS : false
            },
            cta: {
                ctaText: isComingSoon ? 'Coming soon' : ctaText,
                ctoLink,
                customizeText
            }
        }
    }
    return EMPTY_OBJECT;
}

export default withAddToCart(withPageComponents(({
    addToCart,
    addCTOToCart,
    product,
    images,
    imageIndex,
    setImageIndex }) => {
    return (<PriceContainer products={[product]}>
        {
            ({ prices }) => {
                const productPrice = prices[product.sku];
                return (<AddOnPrice sku={product.sku} price={productPrice}>
                    {
                        ({ totalPrice }) => {
                            const { data, cta } = getModalData(product, images, totalPrice);
                            return (<GalleryModal
                                isOpen={imageIndex > -1}
                                initialSlide={Math.max(imageIndex, 0)}
                                data={data}
                                onModalClose={() => setImageIndex(-1)}
                                onAdd={() => {
                                    if (product.prdClass === 'CTO') {
                                        document.location.href = cta.ctoLink;
                                    } else {
                                        //TODO: temp fix to trigger xsell modal
                                        let mainBtn = document.getElementById("pdpAddToCartBtn")
                                        if (mainBtn) {
                                            mainBtn.click();
                                        } else {
                                            addToCart(product, 1);
                                        }
                                    }
                                }}
                                addText={cta.customizeText || cta.ctaText}
                            />);
                        }
                    }</AddOnPrice>);
            }
        }
    </PriceContainer>);
}, { components: ['product'] }));
